import React from 'react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';

import Icon from 'app/components/commons/Icon';
import RewriteNavLink from 'app/components/routing/RewriteNavLink';
import { toggleMobileMenu } from 'app/actions/uiActions';

const MobileNav = () => {
  const dispatch = useDispatch();

  return (
    <MobileNavContainer>
      <MobileNavLink
        to="/lobby"
        activeStyle={{
          color: '#ff0056'
        }}
      >
        <StyledIcon type="icon_menu_lobby" />
        <MobileNavButtonText>LOBBY</MobileNavButtonText>
      </MobileNavLink>
      <MobileNavLink
        to="/live-challenges"
        activeStyle={{
          color: '#ff0056'
        }}
      >
        <StyledIcon type="icon_menu_live_now" />
        <MobileNavButtonText>LIVE NOW</MobileNavButtonText>
      </MobileNavLink>
      <MobileNavLink
        to="/rapidfire"
        activeStyle={{
          color: '#ff0056'
        }}
      >
        <StyledIcon type="icon_menu_rapidfire" />
        <MobileNavButtonText>RAPID FIRE</MobileNavButtonText>
      </MobileNavLink>
      <MobileNavButton onClick={() => dispatch(toggleMobileMenu())} id="gift">
        <StyledIcon type="icon-more-horizontal" />
        <MobileNavButtonText>MORE</MobileNavButtonText>
      </MobileNavButton>
    </MobileNavContainer>
  );
};

export default MobileNav;

const MobileNavContainer = styled.div(({ theme }) => ({
  display: 'flex',
  position: 'fixed',
  bottom: 0,
  zIndex: theme.zIndex.menu - 1,
  width: '100%',
  height: 80,
  backgroundColor: theme.color.basis1
}));

const MobileNavLink = styled(RewriteNavLink)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  color: theme.color.white
}));

const MobileNavButton = styled.button(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  color: theme.color.white
}));

const StyledIcon = styled(Icon)({
  width: 25,
  height: 25,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

const MobileNavButtonText = styled.p({
  fontSize: 12,
  marginTop: 8,
  marginBottom: 0
});
